import type { FC } from 'react';
import { Card, CardContent, CardHeader, IconButton, InfoIcon as Info, styled, Tooltip, useTheme } from '@/shared/ui/mui';
import type { StyledCardProps } from './types';

const StyledCardWrapper = styled(Card)(() => ({
  height: '100%',
  '& .MuiCardHeader-root': {
    paddingBottom: 0,
  },
  '& .MuiCardContent-root': {
    height: '100%',
  },
}));

export const StyledCard: FC<StyledCardProps> = ({
  title,
  subheader,
  action,
  icon,
  children,
  noPadding = false,
  sx,
}) => {
  const theme = useTheme();
  return (
    <StyledCardWrapper sx={sx}>
      {(title || action) && (
        <CardHeader
          avatar={icon}
          title={title}
          subheader={subheader}
          action={
            action || (
              <Tooltip title="Click for more information">
                <IconButton>
                  <Info />
                </IconButton>
              </Tooltip>
            )
          }
          sx={{
            bgcolor: theme.palette.primary.ultraLight,
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
            '& .MuiCardHeader-title': {
              fontSize: '1.125rem',
              fontWeight: 600,
            },
            '& .MuiCardHeader-subheader': {
              fontSize: '0.875rem',
            },
          }}
        />
      )}
      <CardContent
        sx={{
          padding: noPadding ? 0 : 2,
          backgroundColor: theme.palette.common.white,
        }}
      >
        {children}
      </CardContent>
    </StyledCardWrapper>
  );
};
